import { PaymentOut } from 'Domain/PaymentPlan/Entity/PaymentPlan';
import CustomTable from 'pages/components/CustomTable';
import { formatPercent, formatPrice, getDateFormat } from 'pages/Utils/Formats';
import { Link } from 'react-router-dom';
import {
  PAYMENT_PLAN_DETAIL,
  getUrl,
} from 'Infrastructure/config/routesConfig';
import PaymentOutStatusChip from 'pages/components/Status/PaymentOutStatusChip';
import moment from 'moment';

type PaymentPayOutsProps = {
  paymentsOut: Array<PaymentOut>;
};

export default function PaymentPayOuts({ paymentsOut }: PaymentPayOutsProps) {
  return (
    <CustomTable data={formatPayout(paymentsOut)} config={getTableConfig()} />
  );
}

function formatPayout(paymentsOut: Array<PaymentOut>) {
  const tableData: Array<any> = [];

  paymentsOut.forEach((paymentOut) => {
    const ttcFees = paymentOut.paymentAmount - paymentOut.toPayAmount;
    const feesAmount = (ttcFees * 100) / (100 + paymentOut.vat);
    const vatAmount = ttcFees - feesAmount;

    const fees =
      paymentOut.fees !== 0
        ? `${formatPrice(feesAmount)} (${formatPercent(paymentOut.fees)})`
        : '0%';

    const vat =
      paymentOut.vat !== 0
        ? `${formatPrice(vatAmount)} (${formatPercent(paymentOut.vat)})`
        : '0%';

    tableData.push({
      sequence: (
        <Link
          style={{ textDecoration: 'none' }}
          to={getUrl(PAYMENT_PLAN_DETAIL, {
            id: paymentOut.paymentPlanPublicId,
          })}
        >
          {paymentOut.sequence}
        </Link>
      ),
      date: moment(paymentOut.date).format(getDateFormat()),
      paymentAmount: formatPrice(paymentOut.paymentAmount),
      fees: fees,
      vat: vat,
      toPayAmount: formatPrice(paymentOut.toPayAmount),
      status: <PaymentOutStatusChip status={paymentOut.status} />,
    });
  });

  return tableData;
}

function getTableConfig() {
  return {
    sequence: { sx: { width: '20px' } },
    status: { align: 'right' },
  };
}
